import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var ProfileSystemIcon = function ProfileSystemIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M12 12.75c5.799 0 10.5 4.701 10.5 10.5a.75.75 0 11-1.5 0 9 9 0 00-18 0 .75.75 0 11-1.5 0c0-5.799 4.701-10.5 10.5-10.5zM12 0a6 6 0 110 12 6 6 0 010-12zm0 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z"
  })));
};

ProfileSystemIcon.displayName = "ProfileSystemIcon";
ProfileSystemIcon.defaultProps = {
  size: 24
};
ProfileSystemIcon.displayName = "ProfileSystemIcon";
ProfileSystemIcon.iconName = "Profile";
export default ProfileSystemIcon;